import {Injectable} from '@angular/core';
import * as FileSaver from 'file-saver';
import * as JSZipUtils from 'jszip-utils';
import {UploadService} from '../upload/upload.service';

@Injectable()
export class DownloadService {

    private blobsUrl = 'api/storage/blobs';

    constructor(private uploadService: UploadService) {}

    downloadBlob(zipSaisine) {
        return new Promise((resolve, reject) => {
            Promise.all(zipSaisine.documents.map(doc => {
                return this.getFile(zipSaisine, doc);
            })).then(() => {
                zipSaisine.zip.generateAsync({type: 'blob'})
                    .then((content) => {
                        FileSaver.saveAs(content, zipSaisine.name);
                        resolve();
                    });
            }).catch(err => {
                reject();
            });
        });
    }

    getFile(zipSaisine, doc) {
        let options = { binary: true };
        return new Promise((resolve, reject) => {
            this.uploadService.tokenForBlob(doc.blobId).subscribe(token => {
                let url = `${this.blobsUrl}/${doc.blobId}?token=${token}`;

                JSZipUtils.getBinaryContent(url, function (err, data) {
                    if (!err) {
                        zipSaisine.zip.file(doc.getDocName(), data, options);
                    }
                    resolve();
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/download/download.service.ts